import React, { FunctionComponent } from "react"

interface FilterTagProps {
	filterName: string
	active?: boolean
	inActive?: boolean
	isMandatory?: boolean
	passive?: boolean
	role?: number
	level?: number
	status?: boolean
}

const FilterTag: FunctionComponent<FilterTagProps> = ({ filterName, active, inActive, isMandatory, passive, role, level, status }) => {
	let allStyles = `filter-tag`

	if (active) {
		allStyles += " filter-tag-active"
	} else if (inActive) {
		allStyles += " filter-tag-inactive"
	} else if (isMandatory) {
		allStyles += " filter-tag-mandatory"
	} else if (passive) {
		allStyles += " filter-tag-passive"
	} else if (level != null) {
		switch (level) {
			case 1: allStyles += " filter-tag-intro"
				break;
			case 2: allStyles += " filter-tag-intermediate"
				break;
			case 3: allStyles += " filter-tag-advanced"
				break;
			default:
				allStyles += " filter-tag-passive"
		}
	} else if (role != null) {
		switch (role) {
			case 0: allStyles += " filter-tag-user"
				break;
			case 1: allStyles += " filter-tag-admin"
				break;
			case 2: allStyles += " filter-tag-readonly"
				break;
			default:
				allStyles += " filter-tag-passive"
		}
	} else if (status != null) {
		if (status)
			allStyles += " filter-tag-user"
		else
			allStyles += " filter-tag-admin"
	}

	return (
		<div className={allStyles}>
			<div className='filter-tag-text'>{filterName}</div>
		</div>
	)
}

export default FilterTag